// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"c97c0565","355":"4102b574","458":"6157445e","659":"4ce2a178","699":"fc8cbbcf","723":"a34a25a7","796":"39917577","871":"a0771b96","897":"f5625d39","968":"8a601804"}[chunkId] + ".chunk.js";
};